import _ from "lodash";

export class ValidationRules{
    /**
     *
     * @param {*} validations
     */
    constructor(validations) {
        this.validations = validations;
    }

    /**
     *
     * @param keys
     * @returns {Array<Pick<ValidationRules, "all" | "only" | "except" | "validations">[keyof Pick<ValidationRules, "all" | "only" | "except" | "validations">]>}
     */
    only(keys) {
        return _.values(_.pick(this.validations, keys));
    }

    /**
     *
     * @param keys
     * @returns {unknown[]}
     */
    except(keys) {
        return _.values(_.omit(this.validations, keys));
    }

    /**
     *
     * @returns {Array<ValidationRules[keyof ValidationRules]>}
     */
    all() {
        return _.values(this.validations);
    }
}
